import { z } from 'zod'

export const bookingValidation = z.object({
  firstName: z.string().min(1, { message: 'First name is required' }),
  lastName: z.string().min(1, { message: 'Last name is required' }),
  phoneNumber: z.string().regex(/^\d{10}$/, { message: 'Phone number must be 10 digits' }),
  email: z.string().min(1, { message: 'Email is required' }),
  // OPTIMIZE: select a date in two weeks from today and wednesday, saturday, sunday
  pickupDate: z.string().min(1, { message: 'Pickup date is required' }),
  pickupTime: z.string().min(1, { message: 'Pickup time is required' }),
  address: z.object({
    streetAddress: z.string().min(1, { message: 'Street address is required' }),
    province: z.string().min(1, { message: 'Province is required' }),
    city: z.string().min(1, { message: 'City is required' }),
    postalCode: z.string().min(1, { message: 'Postal code is required' }),
    country: z.string().min(1, { message: 'Country is required' }),
  }),
  description: z.string().optional(),
})

export type BookingFormData = z.infer<typeof bookingValidation>
